'use client';

import UserLight from '../../../../public/icons/user_light.svg';
import Logo from '../../../../public/icons/logo.svg';
import Image from 'next/image';
import { Button } from 'antd';
import { Categories } from './categories/categories';

import { useNavigate } from '../../../../utils/navigate-to-products';
import { useRouter } from 'next/navigation';
import { getIsAuthorized, getIsGuest, LoginModal } from '@/components/login-modal/login-modal';
import { useState } from 'react';

import styles from './navbar.module.css';
import ScrollableContainer from '@/ui/scrollable-container/scrollable-container';
import { ClientCategory, ClientSubcategory } from '@/api/types/categories';
import { withCategories } from '@/api/categories';
import { useCategory } from '@/app/selectedCategoryContext';
import { useInfo } from '@/app/infoContext';

const userIcon = <Image src={UserLight} alt={'profile'} width={32} height={32} />;

export const Navbar = () => {
  const { navigateToTop } = useNavigate();
  const router = useRouter();
  const { isMobile } = useInfo();
  const [isLoginModalVisible, setIsLoginModalVisible] = useState(false);

  const onUserClick = () => {
    const token = getIsAuthorized();
    if (!token || getIsGuest()) {
      setIsLoginModalVisible(true);
    } else {
      router.push('/user');
    }
  };

  const onLogoClick = () => {
    navigateToTop();
  };


  return (
    <header className={styles.header}>
      <LoginModal
        isOpen={isLoginModalVisible}
        setIsOpen={setIsLoginModalVisible}
        onLogin={() => router.push('/user')}
      />
      <Image priority src={Logo} alt={'logo'} onClick={onLogoClick} style={{ cursor: 'pointer' }} />

      {!isMobile && (
        <div className={styles.categoriesWrapper}>
          <Categories></Categories>
        </div>
      )}

      <Button
        color="default"
        className={styles.userIcon}
        icon={userIcon}
        size="large"
        shape="circle"
        onClick={onUserClick}
      />
    </header>
  );
};

export const CategoriesMobile: React.FC = withCategories(({ categories }) => {
  const { select, state } = useCategory();
  const selectedCategory = categories.find((val) => val.id === state.categoryId);
  const selectedSubcategory = selectedCategory?.subcategories?.find((val) => val.id === state.subcategoryId);

  const handleCategoryClick = (category: ClientCategory) => {
    select({ categoryId: category.id });
  };

  const handleSubcategoryClick = (subcategory: ClientSubcategory) => {
    select({ ...state, subcategoryId: subcategory.id });
  };

  return (
    <div className={styles.navbar}>
      <ScrollableContainer shouldShowArrow={false} style={{ backgroundColor: 'white' }}>
        <div className={styles.categories}>
          {categories.map((category) => (
            <div
              key={category.id}
              className={state.categoryId === category.id ? styles.categoryActive : styles.category}
              onClick={() => handleCategoryClick(category)}
            >
              {category.categoryName}
            </div>
          ))}
        </div>
      </ScrollableContainer>
      <ScrollableContainer shouldShowArrow={false} style={{ backgroundColor: 'white' }}>
        {categories.find((val) => val.id === state.categoryId)?.subcategories && (
          <div className={styles.subcategories}>
            {selectedCategory?.subcategories?.map((subcategory) => (
              <div
                key={subcategory.id}
                className={
                  selectedSubcategory?.id === subcategory.id ? styles.categoryActive : styles.category
                }
                onClick={() => handleSubcategoryClick(subcategory)}
              >
                {subcategory.categoryName}
              </div>
            ))}
          </div>
        )}
      </ScrollableContainer>
    </div>
  );
});
